import { ref } from 'vue'
import { defineStore } from 'pinia'
import { generalStore } from './index.js';
import axios from '@/plugins/axios.js';

export const categoriesStore = defineStore('category', () => {
  const store = generalStore();
  var categories = ref(store.getSessionStorage('submenu'))

  /**
   * Function used to obtain with axios all categories with available products on the data base. Persist data on Session Storage
   */
  const loadCategories = async (page) => {
    try {
      await axios.get('/categories.php', {
        params: {
          'type': 'categories',
          page
        }
      }, {
      }).then(response => {
        if (response.status == 204) {
          console.log('redirigir a página de "NO ENCONTRADO"')
        } else {
          categories.value = response['data'];
        }
      })
    } catch (error) {
      console.error("Hubo un error en la solicitud: ", error);
    } finally {
      store.setSessionStorage('persistCategories-' + page, categories.value)
    }
  }

  return {
    loadCategories
  }
})